export default {
  setClubs ({state, commit, rootState}, clubs) {
    commit('SET_CLUBS', clubs)
    if (Array.isArray(clubs) && clubs.length) {
      const [firstClub] = clubs
      commit('SET_DEFAULT_CLUB', firstClub)
    }
  },
  setSelectedClub ({commit}, club) {
    commit('SET_SELECTED_CLUB', club)
  }
}



// WEBPACK FOOTER //
// ./src/store/clubs/clubs.actions.js